
import { GET_GRN_REPORT_DOWNLOAD_FAILURE, GET_GRN_REPORT_DOWNLOAD_REQUEST, GET_GRN_REPORT_DOWNLOAD_SUCCESS, GET_GRN_REPORT_FAILURE, GET_GRN_REPORT_REQUEST, GET_GRN_REPORT_SUCCESS } from "./grnReportTypes";
  
  const initialStateForGrnReport = {
    loading: false,
    grnReport: [],
    error: "",
  };
  
  const getGrnReportReducer = (
    state = initialStateForGrnReport,
    action
  ) => {
    switch (action.type) {
      case GET_GRN_REPORT_REQUEST:
        return {
          ...state,
          loading: true,
        };
      case GET_GRN_REPORT_SUCCESS:
        return {
          loading: false,
          grnReport: action.payload,
          error: "",
        };
      case GET_GRN_REPORT_FAILURE:
        return {
          loading: false,
          grnReport: [],
          error: action.payload,
        };
      default:
        return state;
    }
  };
  
  const initialStateForDownloadGrnReport = {
    loading: false,
    consumptionReport: [],
    error: "",
  };
  
  const downloadGrnReportReducer = (
    state = initialStateForDownloadGrnReport,
    action
  ) => {
    switch (action.type) {
      case GET_GRN_REPORT_DOWNLOAD_REQUEST:
        return {
          ...state,
          loading: true,
        };
      case GET_GRN_REPORT_DOWNLOAD_SUCCESS:
        return {
          loading: false,
          consumptionReport: action.payload,
          error: "",
        };
      case GET_GRN_REPORT_DOWNLOAD_FAILURE:
        return {
          loading: false,
          consumptionReport: [],
          error: action.payload,
        };
      default:
        return state;
    }
  };
  
  export { getGrnReportReducer,
     downloadGrnReportReducer
     };
  